var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./index.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2e7b2c7c\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./index.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/apps/web/conta-whatsapp/index.vue
// module id = 1275
// module chunks = 45